import { Navigate, useLocation } from 'react-router-dom';
import { PATHS } from '@utils/paths';

export function CaseSettingsRootRedirect() {
  const { search } = useLocation();
  return (
    <Navigate
      replace
      to={`${PATHS.PRIVATE_BASE.caseSettings}${PATHS.CASE_SETTINGS_NAVIGATION.basicInformation}${search}`}
    />
  );
}
